import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzEaster80 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzEaster80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_EASTER_80: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_EASTER_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/subscriptions/SubscriptionEaster80'
      ).then((m) => ({
        default: m.SubscriptionsEaster80,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/subscriptions/SubscriptionEaster80'
      ),
  },
  [PageId.CHAT_UPSELL_EASTER_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_EASTER_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_easter/woofz_easter_80/pages/upsell/Upsell'),
  },
  [PageId.DOWNLOAD_EASTER_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzEaster80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
